import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
    const token = sessionStorage.getItem("accessToken");
    return { headers: { Authorization: `Bearer ${token}` } };
}

async function post(path, payload = {}) {
    try {
        const response = await axios.post(
            `${apiBaseUrl}admin/course-details/${path}`,
            payload,
            {
                ...getAdminAuthConfig(),
                headers: { ...getAdminAuthConfig().headers, "Content-Type": "application/json" },
            }
        );
        return response.data;
    } catch (error) {
        console.error(`Course detail ${path} Error:`, error);
        return { status: false, type: "danger", success: "Course detail request failed" };
    }
}

export function getCourseDetailApi(course_id) { return post("view", { course_id }); }
export function createCourseModuleApi(payload) { return post("module/create", payload); }
export function updateCourseModuleApi(payload) { return post("module/update", payload); }
export function deleteCourseModuleApi(module_id) { return post("module/delete", { module_id }); }
export function createCourseLectureApi(payload) { return post("lecture/create", payload); }
export function updateCourseLectureApi(payload) { return post("lecture/update", payload); }
export function deleteCourseLectureApi(lession_id) { return post("lecture/delete", { lession_id }); }
export function createCourseVideoApi(payload) { return post("video/create", payload); }
export function updateCourseVideoApi(payload) { return post("video/update", payload); }
export function deleteCourseVideoApi(course_video_id) { return post("video/delete", { course_video_id }); }
